import React, { useState, useEffect } from 'react';

function DocumentList({ acctNum }) {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDocuments = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await fetch(`/api/documents/${acctNum}`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        setDocuments(result);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (acctNum) fetchDocuments();
  }, [acctNum]);

  // Sort by Date descending (newest first)
  const sortedDocuments = [...documents].sort((a, b) => new Date(b.Date) - new Date(a.Date));

  if (loading) return <div>Loading documents...</div>;
  if (error) return <div>Error loading documents: {error}</div>;
  if (sortedDocuments.length === 0) return <div>No documents found for this candidate.</div>;

  return (
    <div style={{ marginTop: '30px' }}>
      <h3>Candidate Documents</h3>
      <table border="1" style={{ borderCollapse: 'collapse', width: '100%' }}>
        <thead>
          <tr style={{ backgroundColor: '#f2f2f2' }}>
            <th style={{ padding: '8px', textAlign: 'left' }}>Date</th>
            <th style={{ padding: '8px', textAlign: 'left' }}>Document Description</th>
          </tr>
        </thead>
        <tbody>
          {sortedDocuments.map((doc) => (
            <tr key={doc._id}>
              <td style={{ padding: '8px' }}>
                {new Date(doc.Date).toLocaleDateString('en-US', { 
                  year: 'numeric', 
                  month: 'short', 
                  day: 'numeric' 
                })}
              </td>
              <td style={{ padding: '8px' }}>
                <a 
                  href={`/docs/${doc.FilePath}`} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{ color: '#007bff', textDecoration: 'none' }}
                >
                  {doc.DocDesc}
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default DocumentList;